import { CoreModel } from '../core/core.model';
export class AvatarModel extends CoreModel {
/**
 * Type of avatar. Can be: image, icon, text. Default: image.
 */
type?: string;
/**
 * The name of the person from the initials of which the avatar will be generated, based on <b>charsNumber</b>
 */
name?: string;
/**
 * Url for the image
 */
url?: string;
/**
 * Text to be used as avatar
 */
text?: string;
/**
 * Name of icon to be used for cf-icon
 */
iconName?: string;
/**
 * Number of initials simulators in the avatar. Default: 2.
 */
charsNumber?: number;
/**
 * The color that will be applied to text or icons
 */
color?: string;
/**
 * The size to be applied as the height and width of the avatar.
 * Required if you want use your avatar from other sites (Facebook, Google, etc). Default: 70px.
 */
size?: any;
/**
 * The width of the avatar. Has higher priority then <b>size</b>. Default: 70px.
 */
width?: any;
/**
 * The height of the avatar. Has higher priority then <b>size</b>. Default: 70px.
 */
height?: any;
/**
 * Font size for the text (initials or custom text). Default: 30px.
 */
fontSize?: string;
/**
 * Avatar border. Not specified by default.
 */
border?: string;
/**
 * Avatar border radius. Not specified by default.
 */
borderRadius?: string;
/**
 * Avatar background. Not specified by default.
 */
background?: string;
/**
 * Avatar background-image. Not specified by default.
 */
backgroundImage?: string;
/**
 * Avatar shadow. Not specified by default.
 */
shadow?: string;
/**
 * Facebook ID
 */
facebookId?: string;
/**
 * Google ID
 */
googleId?: string;
/**
 * Twitter Handle
 */
twitterId?: string;
/**
 * VK ID
 */
vkontakteId?: string;
/**
 * Skype ID
 */
skypeId?: string;
/**
 * email or md5 email related to gravatar
 */
gravatarId?: string;
/**
 * Github ID
 */
githubId?: string;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function AvatarModel_tsickle_Closure_declarations() {
/**
 * Type of avatar. Can be: image, icon, text. Default: image.
 * @type {?}
 */
AvatarModel.prototype.type;
/**
 * The name of the person from the initials of which the avatar will be generated, based on <b>charsNumber</b>
 * @type {?}
 */
AvatarModel.prototype.name;
/**
 * Url for the image
 * @type {?}
 */
AvatarModel.prototype.url;
/**
 * Text to be used as avatar
 * @type {?}
 */
AvatarModel.prototype.text;
/**
 * Name of icon to be used for cf-icon
 * @type {?}
 */
AvatarModel.prototype.iconName;
/**
 * Number of initials simulators in the avatar. Default: 2.
 * @type {?}
 */
AvatarModel.prototype.charsNumber;
/**
 * The color that will be applied to text or icons
 * @type {?}
 */
AvatarModel.prototype.color;
/**
 * The size to be applied as the height and width of the avatar.
 * Required if you want use your avatar from other sites (Facebook, Google, etc). Default: 70px.
 * @type {?}
 */
AvatarModel.prototype.size;
/**
 * The width of the avatar. Has higher priority then <b>size</b>. Default: 70px.
 * @type {?}
 */
AvatarModel.prototype.width;
/**
 * The height of the avatar. Has higher priority then <b>size</b>. Default: 70px.
 * @type {?}
 */
AvatarModel.prototype.height;
/**
 * Font size for the text (initials or custom text). Default: 30px.
 * @type {?}
 */
AvatarModel.prototype.fontSize;
/**
 * Avatar border. Not specified by default.
 * @type {?}
 */
AvatarModel.prototype.border;
/**
 * Avatar border radius. Not specified by default.
 * @type {?}
 */
AvatarModel.prototype.borderRadius;
/**
 * Avatar background. Not specified by default.
 * @type {?}
 */
AvatarModel.prototype.background;
/**
 * Avatar background-image. Not specified by default.
 * @type {?}
 */
AvatarModel.prototype.backgroundImage;
/**
 * Avatar shadow. Not specified by default.
 * @type {?}
 */
AvatarModel.prototype.shadow;
/**
 * Facebook ID
 * @type {?}
 */
AvatarModel.prototype.facebookId;
/**
 * Google ID
 * @type {?}
 */
AvatarModel.prototype.googleId;
/**
 * Twitter Handle
 * @type {?}
 */
AvatarModel.prototype.twitterId;
/**
 * VK ID
 * @type {?}
 */
AvatarModel.prototype.vkontakteId;
/**
 * Skype ID
 * @type {?}
 */
AvatarModel.prototype.skypeId;
/**
 * email or md5 email related to gravatar
 * @type {?}
 */
AvatarModel.prototype.gravatarId;
/**
 * Github ID
 * @type {?}
 */
AvatarModel.prototype.githubId;
}

